import React from 'react';

import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { Text, TextProps } from '.';

export interface TextSBProps {
  text: string;
  variant?: TextProps['variant'];
  color?: {
    colorKey?: TextProps['color'];
  };
}

export default function TextSB({
  block,
  inner,
}: BlockComponentModel<TextSBProps, TextProps>) {
  const { text, color } = block;

  return (
    <Text color={color?.colorKey} {...inner}>
      {text}
    </Text>
  );
}
